// extracted by mini-css-extract-plugin
module.exports = {"container":"_61cc05a7c9--container--3UM__","wrapper":"_61cc05a7c9--wrapper--2-zpc","title":"_61cc05a7c9--title--1Hg4A","description":"_61cc05a7c9--description--Au2uZ"};